import { transformActions } from 'utils/';
import { GET_STOCK_CONDITION } from 'actions/types';

const initialState = { data: [], isLoading: false };

/**
 * @description Stores stock condition array details in redux state
 * @returns {[]}
 * @param {[]} state
 * @param {{}} action
 */
export function stockCondition(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_STOCK_CONDITION];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (type === GET_STOCK_CONDITION) {
    return { ...state, isLoading: true };
  }
  if (success.includes(type)) {
    return { data: payload, isLoading: false };
  }
  if (failure.includes(type)) {
    return { ...state, isLoading: false };
  }
  return state;
}
